import React from 'react';
import PropTypes from 'prop-types';

import HouseholdSection from '../HouseholdSection';
import { getIncomeToRentRatioRollup, getRentPriceAsDollars, getTotalIncome } from '../Household.util';
import VoucherPopover from './VoucherPopover';
import { getHasPendingApplicants } from '../../../../../utils/applicants';

export default function IncomeToRentRatioSection({ applicants, invitations, monthlyPayment, ...rest }) {
  const voucherIncome = getTotalIncome(applicants, ['voucher']);
  const totalIncome = getTotalIncome(applicants);
  const ratio = getIncomeToRentRatioRollup(applicants, invitations, monthlyPayment);
  const hasPendingApplicants = getHasPendingApplicants(applicants);
  const rentPrice = getRentPriceAsDollars(monthlyPayment);
  const hasAnyVoucherIncome = voucherIncome > 0;
  const voucherCoversRent = voucherIncome >= rentPrice;
  const totalIncomeCoversRent = totalIncome >= rentPrice;
  return (
    <HouseholdSection
      title={
        <>
          Income-to-rent
          {!hasPendingApplicants && hasAnyVoucherIncome && (
            <VoucherPopover
              voucherCoversRent={voucherCoversRent}
              totalIncomeCoversRent={totalIncomeCoversRent}
              marginLeft="xxs"
            />
          )}
        </>
      }
      text={ratio}
      {...rest}
    />
  );
}

IncomeToRentRatioSection.propTypes = {
  applicants: PropTypes.arrayOf(
    PropTypes.shape({
      currentIncomes: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          amount: PropTypes.number.isRequired,
          type: PropTypes.string,
        }),
      ),
    }),
  ),
  rentPrice: PropTypes.number,
};
